import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'

const rtiadmin = [


    {
        "title": "First Appellate Authority and Transparency Officer",
        "Name": "Prof. Venkata Ramana Badarla",
        "NameLink": "#",
        "Designation": "Registrar In-charge",
        "Mobile": "0877-250 3041",
        "Email": "registrar@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/ramana.jpg"
    },
    {
        "title": "Central Public Information Officer",
        "Name": "Mr.Umesh Kumar Singh",
        "NameLink": "#",
        "Designation": "Assistant Registrar",
        "Mobile": "0877-250 3535",
        "Email": "cpio@iittp.ac.in",
        "Image": "../assets/img/IITTP/institute/umeshkumarsingh.png"
    },




]

function RTIAdministrationPg() {

    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Administration" />


            <section className="team-area fix p-relative pt-120 pb-80">
                <div className="container">

                    <div className="row">
                        <div className="col-md-12 p-relative c-lineheight2">
                            <div className="row">
                                <div className="col-md-3 text-center">
                                    <img src="https://files.iittp.ac.in/pics/rti.gif" width="200" height="200" />
                                </div>


                                <div className="col-md-9">
                                    <div className="section-title center-align mb-50 text-center wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s">
                                        <h1 className='c-heading '>Right to Information</h1>
                                        <p className='mb-3'> Right to Information (RTI) is an <Link to={"https://iittp.ac.in/rti"} className='c-link' target='_blank'>Act of the Indian Parliament </Link> enforced from the year 2005, to provide for a practical regime for citizens to secure access to information under the control of public authorities. This aims to promote transparency and accountability in the working of every public authority. IIT Tirupati being an Autonomous Institute under Ministry of Human Resource Development is covered under this Act</p>
                                    </div>
                                </div>

                            </div>


                        </div>
                        <div className='justify-content-around mb-3'>
                            <h4 className='c-headline mt-5 mb-1'></h4>
                            <h4 className='c-headline mt-5 mb-5'>
                                <h4><Link to={"/rti-section-4"} className='c-link' target='_blank'> RTI Section 4 </Link></h4>
                            </h4>                          
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <div className='c-lineheight3 ms-4'>
                                <p className='mb-3'> For RTI queries related to IIT Tirupati please write to<br /> <b> Central Public Information Office(CPIO)</b> <br /> Indian Institute of Technology Tirupati<br />Yerpedu – Venkatagiri Road,<br />Yerpedu Post,Tirupati District,<br />Andhra Pradesh - 517619.<br />Email : <span className='c-link'> cpio@iittp.ac.in</span></p>
                            </div>

                        </div>

                        {rtiadmin.map((rtiadmin, index) => (
                            <div key={rtiadmin.Email} className="col-xl-4 col-md-4">
                                
                                <div className="single-team mb-40 text-center">
                                    <h4> {rtiadmin.title} </h4>
                                    <div className="team-thumb">
                                        <div className="brd">
                                            <Link to="/team-single">
                                                <img src={rtiadmin.Image} alt="img" />
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="team-info">
                                        <h4>
                                            <Link to={rtiadmin.NameLink}>{rtiadmin.Name}</Link>
                                        </h4>
                                        <div className="text-dark c-lineheight2">
                                            <p>
                                                <i className="fal fa-graduation-cap me-2" />
                                                {rtiadmin.Designation}
                                            </p>

                                            <p className="text-dark"> {rtiadmin.Mobile}</p>
                                            {(rtiadmin.Email !== undefined && rtiadmin.Email !== "") && (
                                                <p className="text-dark">
                                                  
                                                    Email : <span className='c-link'> {rtiadmin.Email}</span>
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}

                        <div className='justify-content-around mb-3'>
                            <h4 className='c-headline mt-5 mb-1'></h4>
                            <h4 className='c-headline mt-5 mb-5'>
                                <h4>For Online requests : <Link className='c-link' to="https://rti.gov.in/" target="_blank">Click Here</Link><br /> </h4>
                            </h4>
                            
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

// // Function to parse HTML content and extract text
// function parseHTML(htmlString) {
//     const tempElement = document.createElement('div');
//     tempElement.innerHTML = htmlString;
//     return tempElement.textContent || tempElement.innerHTML || '';
// }


export default RTIAdministrationPg